import { IconProps } from '../icons';

export const ReplanTextInactiveIcon = ({
    width = 105,
    height = 17,
    color = '#D7D9E3',
}: IconProps) => {
    return (
        <svg
            width={width}
            height={height}
            viewBox="0 0 105 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M4.62597 6.72784C4.62597 6.54682 4.51535 6.38592 4.34439 6.32558L0 4.69141V15.658C0 15.8943 0.191073 16.0904 0.432428 16.0904H4.20863C4.44496 16.0904 4.64106 15.8943 4.64106 15.658L4.62597 6.72784Z"
                fill="#D7D9E3"
            />
            <path
                d="M14.064 9.9709L6.29031 6.98916C6.00873 6.88357 5.70703 7.08973 5.70703 7.39142V11.3537H7.39652L10.5442 15.8992C10.6246 16.0148 10.7554 16.0852 10.9012 16.0852H15.14C15.497 16.0852 15.6981 15.6779 15.4819 15.3913L12.1884 11.052C12.8823 10.8106 13.5209 10.4436 14.064 9.9709Z"
                fill="#D7D9E3"
            />
            <path
                d="M4.64106 0H0.432428C0.196101 0 0 0.191073 0 0.432428V3.72592L4.05778 5.24948C4.33936 5.35507 4.64106 5.14891 4.64106 4.84722V0Z"
                fill="#D7D9E3"
            />
            <path
                d="M15.7132 3.55999C14.9389 1.34254 12.832 0 10.3531 0H5.70703V3.12756C5.70703 3.36389 5.8981 3.55999 6.13946 3.55999H15.7132Z"
                fill="#D7D9E3"
            />
            <path
                d="M5.70703 4.92769V5.67187C5.70703 5.85289 5.81765 6.01379 5.98861 6.07413L14.6975 9.32237C15.5825 8.32175 16.03 7.11497 16.03 5.67187C16.03 5.26961 15.9847 4.87238 15.9043 4.49023H6.13443C5.8981 4.50029 5.70703 4.69136 5.70703 4.92769Z"
                fill="#D7D9E3"
            />
            <path
                d="M29.1744 12.0134L27.6136 9.77114H27.5256H25.8989V12.0134H24.0303V3.94556H27.5256C28.2291 3.94556 28.8666 4.05548 29.3942 4.2973C29.9218 4.53911 30.3175 4.86886 30.6033 5.30853C30.8891 5.74819 31.021 6.25382 31.021 6.86935C31.021 7.4629 30.8671 7.9905 30.5813 8.40819C30.2955 8.84785 29.8778 9.1776 29.3502 9.39744L31.1529 11.9915H29.1744V12.0134ZM28.6907 5.83613C28.405 5.59432 27.9653 5.46241 27.4157 5.46241H25.8989V8.27628H27.4157C27.9653 8.27628 28.405 8.14437 28.6907 7.90256C28.9765 7.66074 29.1304 7.30902 29.1304 6.86935C29.1304 6.42969 28.9985 6.07795 28.6907 5.83613Z"
                fill="#D7D9E3"
            />
            <path
                d="M39.0226 10.5183V12.0132H32.7793V3.94531H38.8687V5.44019H34.6259V7.19886H38.3631V8.64975H34.6259V10.5183H39.0226Z"
                fill="#D7D9E3"
            />
            <path
                d="M45.86 4.29706C46.3876 4.53888 46.7833 4.86862 47.0691 5.30829C47.3549 5.74795 47.4868 6.25358 47.4868 6.86911C47.4868 7.46266 47.3549 7.96828 47.0691 8.40795C46.7833 8.84761 46.3876 9.17736 45.86 9.41918C45.3324 9.66099 44.7169 9.7709 43.9914 9.7709H42.3647V11.9912H40.4961V3.92334H43.9914C44.7169 3.94532 45.3324 4.07723 45.86 4.29706ZM45.1785 7.90232C45.4643 7.6605 45.6182 7.30878 45.6182 6.86911C45.6182 6.40746 45.4643 6.07771 45.1785 5.83589C44.8928 5.59408 44.4531 5.46217 43.9035 5.46217H42.3867V8.25406H43.9035C44.4531 8.27604 44.8708 8.14414 45.1785 7.90232Z"
                fill="#D7D9E3"
            />
            <path
                d="M48.2998 3.94531H50.1684V10.4964H54.2133V12.0132H48.2998V3.94531Z"
                fill="#D7D9E3"
            />
            <path
                d="M60.8083 10.2765H57.0711L56.3676 12.0132H54.4551L58.0384 3.94531H59.885L63.4902 12.0132H61.5337L60.8083 10.2765ZM60.2147 8.86959L58.9397 5.79192L57.6646 8.86959H60.2147Z"
                fill="#D7D9E3"
            />
            <path
                d="M71.426 3.94531V12.0132H69.8871L65.8642 7.11092V12.0132H64.0176V3.94531H65.5564L69.5574 8.84761V3.94531H71.426Z"
                fill="#D7D9E3"
            />
            <path
                d="M74.2624 11.7495C74.0425 11.5296 73.9326 11.2658 73.9326 10.9361C73.9326 10.6063 74.0425 10.3425 74.2624 10.1447C74.4822 9.94682 74.746 9.83691 75.0538 9.83691C75.3615 9.83691 75.6253 9.94682 75.8452 10.1447C76.065 10.3425 76.1749 10.6063 76.1749 10.9361C76.1749 11.2658 76.065 11.5296 75.8452 11.7495C75.6253 11.9693 75.3615 12.0792 75.0538 12.0792C74.724 12.0792 74.4602 11.9693 74.2624 11.7495Z"
                fill="#D7D9E3"
            />
            <path
                d="M79.4507 11.5956C78.7912 11.2438 78.2636 10.7382 77.8899 10.1227C77.5162 9.48516 77.3184 8.78169 77.3184 7.99029C77.3184 7.19889 77.5162 6.47343 77.8899 5.8579C78.2636 5.24237 78.7912 4.73675 79.4507 4.38501C80.1102 4.03328 80.8577 3.85742 81.693 3.85742C82.3965 3.85742 83.012 3.98932 83.5836 4.23114C84.1552 4.47296 84.6168 4.82469 84.9905 5.28634L83.8034 6.38551C83.2539 5.74799 82.5944 5.44023 81.781 5.44023C81.2754 5.44023 80.8357 5.55014 80.44 5.76998C80.0443 5.98981 79.7365 6.29756 79.5167 6.69326C79.2969 7.08896 79.1869 7.52864 79.1869 8.03426C79.1869 8.53987 79.2969 8.97953 79.5167 9.37524C79.7365 9.77094 80.0443 10.0787 80.44 10.2985C80.8357 10.5184 81.2754 10.6283 81.781 10.6283C82.5944 10.6283 83.2539 10.3205 83.8034 9.68301L84.9905 10.7822C84.6168 11.2438 84.1332 11.5955 83.5616 11.8593C82.9901 12.1012 82.3525 12.2331 81.6711 12.2331C80.8577 12.1232 80.1102 11.9473 79.4507 11.5956Z"
                fill="#D7D9E3"
            />
            <path d="M86.2432 3.94531H88.1117V11.9912H86.2432V3.94531Z" fill="#D7D9E3" />
            <path
                d="M91.6951 5.46217H89.123V3.94531H96.1357V5.46217H93.5637V11.9912H91.6951V5.46217Z"
                fill="#D7D9E3"
            />
            <path
                d="M101.103 9.13339V11.9912H99.2349V9.1114L96.1133 3.94531H98.0918L100.246 7.50662L102.401 3.94531H104.225L101.103 9.13339Z"
                fill="#D7D9E3"
            />
        </svg>
    );
};
